import washAndFoldImg from '../assets/images/wash-fold-round.png';
import dryCleaningImg from '../assets/images/dry-cleaning-round.png';
import washAndIronImg from '../assets/images/wash-iron-round.png';
import premiumLaundryImg from '../assets/images/premium-laundry-round.png';

export const pricingValues =  {
    DRY_CLEANING : [
        {
            PRICEFOR: 'men-icon',
            DETAILS: [
                {
                    item: 'Shirt/T-shirt/Pant',
                    price: '85'
                },
                {
                    item: 'Denim/Jeans Pant',
                    price: '115'
                },
                {
                    item: 'Kurta/Jubba',
                    price: '180'
                },
                {
                    item: 'Kurta/Jubba - Designer',
                    price: '320'
                },
                {
                    item: 'Normal Dhoti',
                    price: '100'
                },
                {
                    item: 'Silk Dhoti',
                    price: '200'
                },
                {
                    item: 'Blazer/Coat/Safar',
                    price: '400'
                },
                {
                    item: 'Suit 2 Pcs.',
                    price: '480'
                },
                {
                    item: 'Suit 3 Pcs.',
                    price: '550'
                },
                {
                    item: 'Suit 5 Pcs.',
                    price: '600'
                },
                {
                    item: 'Jacket',
                    price: '325'
                },
                {
                    item: 'Jacket Leather',
                    price: '600'
                },
                {
                    item: 'Sherwani/Bandgala',
                    price: '600+'
                },
                {
                    item: 'Tie/Underwear/Vest',
                    price: '40'
                },
                {
                    item: 'Shirt/Towel silk',
                    price: '100'
                },
                {
                    item: 'Cap',
                    price: '90'
                },
                {
                    item: 'Hat',
                    price: '125'
                }
            ]
        },
        {
            PRICEFOR: 'female-icon',
            DETAILS: [
                {
                    item: 'Top/Kurti/Kameez',
                    price: '100'
                },
                {
                    item: 'Tops designer',
                    price: '150+'
                },
                {
                    item: 'Tops designer - Heavy',
                    price: '500+'
                },
                {
                    item: 'Kurti fancy',
                    price: '500'
                },
                {
                    item: 'Salwar/Chudidhar',
                    price: '250'
                },
                {
                    item: 'Dupatta',
                    price: '70'
                },
                {
                    item: 'Saree Silk/Nrml',
                    price: '350+/275'
                },
                {
                    item: 'Saree Designer',
                    price: '500+'
                },
                {
                    item: 'Blouse Nrml/Designer',
                    price: '95/150'
                },
                {
                    item: 'Lehenga',
                    price: '450+'
                },
                {
                    item: 'Shawl',
                    price: '250+'
                },
                {
                    item: 'Cap',
                    price: '90'
                },
                {
                    item: 'Hat',
                    price: '125'
                },
                {
                    item: 'Underwear/Vest',
                    price: '40'
                }
            ]
        },
        {
            PRICEFOR: 'house-icon',
            DETAILS: [
                {
                    item: 'Curtains - French door',
                    price: '250'
                },
                {
                    item: 'Curtains - Small S/D',
                    price: '140/160'
                },
                {
                    item: 'Curtains - Big S/D',
                    price: '175/235'
                },
                {
                    item: 'Pillow',
                    price: '125'
                },
                {
                    item: 'Pillow Cover-Cotton',
                    price: '25'
                },
                {
                    item: 'Blanket/Quilt/Rug S/D',
                    price: '325/450+'
                },
                {
                    item: 'Bedsheet S/D',
                    price: '160/230'
                },
                {
                    item: 'Bedspread S/D',
                    price: '225/310'
                },
                {
                    item: 'Quilt S/D',
                    price: '410/555+'
                },
                {
                    item: 'Carpet',
                    price: '30/sq ft'
                },
                {
                    item: 'Face towel',
                    price: '40+'
                },
                {
                    item: 'Large towel',
                    price: '75'
                },
                {
                    item: 'Bath robe',
                    price: '100'
                },
                {
                    item: 'Socks pair',
                    price: '50'
                }
            ]
        },
        {
            PRICEFOR: 'shoes-icon',
            DETAILS: [
                {
                    item: 'Sports Shoes',
                    price: '300'
                },
                {
                    item: 'Canvas Shoes',
                    price: '300'
                },
                {
                    item: 'Leather Shoes',
                    price: '500'
                },
                {
                    item: 'Suede Leather Shoes',
                    price: '500'
                }
            ]
        }
    ],
    LAUNDRY : [
        {
            serviceName: 'Wash & Fold',
            price: '₹ 135',
            subText: ' (Incl tax)',
            price_unit: '(Per Kg)',
            details: {
                turnAroundTime: '48 hrs turn around',
                packagingType: 'Combined Packaging',
                clothType: 'For Casual & Regular wear'
            },
            tc: 'Minimum 4 Kgs'
        },
        {
            serviceName: 'Wash & Iron',
            price: '₹ 185',
            subText: ' (Incl tax)',
            price_unit: '(Per Kg)',
            details: {
                turnAroundTime: '48 hrs turn around',
                packagingType: 'Combined Packaging',
                clothType: 'For Casual & Regular wear'
            },
            tc: 'Minimum 4 Kgs'
        },
        {
            serviceName: 'Premium Laundry',
            price: '₹ 250',
            subText: ' (Incl tax)',
            price_unit: '(Per Kg)',
            details: {
                turnAroundTime: '72 hrs turn around',
                packagingType: 'Individual Packaging',
                clothType: 'For Formals, Whites & Branded Clothes'
            },
            tc: 'Minimum 4 Kgs'
        },
        {
            serviceName: 'Dry Cleaning',
            price: '₹ 80/piece',
            subText: ' (Incl tax)',
            price_unit: '',
            details: {
                turnAroundTime: '72 hrs turn around',
                packagingType: 'Individual Packaging',
                clothType: 'For Expensive and Fancy Garments'
            },
            tc: ''
        }
    ],
    PRICING_DETAIL: {
        TITLE: 'Service Details',
        SERVICES_OFFERED : [
            {
                serviceName: 'Wash & Fold',
                imageUrl: washAndFoldImg,
                price: '₹ 135',
                price_unit: 'Per Kg',
                details: [
                    '48 hrs Turnaround time',
                    'Machine Wash & Tumble Dry',
                    'Combined Packaging',
                    'Preferred for Casual and Regular Wears',
                    '',
                    '* Minimum 4 Kgs'
                ],
                tc: ''
            },
            {
                serviceName: 'Wash & Iron',
                imageUrl: washAndIronImg,
                price: '₹ 185',
                price_unit: 'Per Kg',
                details: [
                    '48 hrs Turnaround time',
                    'Machine Wash & Tumble Dry',
                    'Combined Packaging',
                    'Preferred for Casual and Regular Wears',
                    'Crisp Ironing through Steam/Hard Press',
                    '* Minimum 4 Kgs'
                ],
                tc: ''
            },
            {
                serviceName: 'Premium Laundry',
                imageUrl: premiumLaundryImg,
                price: '₹ 250',
                price_unit: 'Per Kg',
                details: [
                    '72 hrs Turnaround time',
                    'Machine Wash & Dry',
                    'Individual Packaging with cushioning materials',
                    'Preferred for Formals, Whites, Branded clothes and other Expensive Garments',
                    'Guaranteed Cuff & Collar Cleaning',
                    '* Minimum 4 Kgs'
                ],
                tc: ''
            },
            {
                serviceName: 'Dry Clean',
                imageUrl: dryCleaningImg,
                price: '₹ 80',
                price_unit: 'Per Piece',
                details: [
                    '72 hrs Turnaround time',
                    'Eco-friendly & organic detergents, Spot removal of stains.',
                    'Individual Packaging with cushioning materials',
                    'Preferred for Expensive & Fancy Garments / Heavy Items',
                    'Crisp Ironing through Steam/Hard Press',
                    '* Price may vary as per cloth.'
                ],
                tc: '* Price may vary as per cloth'
            }
        ],
        GENERAL_TC: '* All Prices are inclusive of taxes'
    }
}
